var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconbox"},[_c('i',{staticClass:"el-icon-setting"})])
}]

export { render, staticRenderFns }